import {
  BookHeart,
  BrushCleaning,
  CalendarDays,
  Image as ImageIcon,
  ListChecks,
  PersonStanding,
  PiggyBank,
  Salad,
  Settings,
  type LucideIcon,
} from "lucide-react";

export type NavKey =
  "album" | "chores" | "diet" | "money" | "schedule" | "lists" | "diary" | "profile" | "settings";

export interface NavItem {
  key: NavKey;
  /** 画面の見出しと下部ナビの読み上げ名。両方でこれを使う */
  label: string;
  icon: LucideIcon;
}

/**
 * タブの一覧。見出しとナビで同じ名前・同じ絵を使うための一次情報。
 * 別々に書くと、片方だけ直したときに食い違う。
 */
export const NAV_ITEMS: NavItem[] = [
  { key: "album", label: "写真・動画", icon: ImageIcon },
  { key: "chores", label: "家事当番", icon: BrushCleaning },
  { key: "diet", label: "ダイエット", icon: Salad },
  { key: "money", label: "家計簿", icon: PiggyBank },
  { key: "schedule", label: "予定", icon: CalendarDays },
  { key: "lists", label: "共有リスト", icon: ListChecks },
  { key: "diary", label: "交換日記", icon: BookHeart },
  { key: "profile", label: "プロフィール", icon: PersonStanding },
  { key: "settings", label: "設定", icon: Settings },
];

export const NAV_BY_KEY: Record<NavKey, NavItem> = Object.fromEntries(
  NAV_ITEMS.map((item) => [item.key, item]),
) as Record<NavKey, NavItem>;
